module.exports = __webpack_public_path__ + "assets/img/btn-detail-08dec2ea.png";